(function () {
  if (window.apdevDeferredFiltersInitialized) {
    return;
  }

  window.apdevDeferredFiltersInitialized = true;

  const apdevSelectors = {
    form: ".js-apdev-deferred-filters-form",
    button: ".apdev-apply-filters-button",
    externalSort: ".js-sort-select-external",
    priceFrom: 'input[name="filter.v.price.gte"]',
    priceTo: 'input[name="filter.v.price.lte"]'
  };

  const apdevPreservedParams = ["q", "type", "options[prefix]"];

  function apdevGetForm(event) {
    return event.target && event.target.closest(apdevSelectors.form);
  }

  function apdevIsDefaultPriceInput(input) {
    if (!input) {
      return false;
    }

    const value = String(input.value).trim();

    if (value === "") {
      return true;
    }

    if (input.name === "filter.v.price.gte") {
      return Number(value) === Number(input.min);
    }

    if (input.name === "filter.v.price.lte") {
      return Number(value) === Number(input.max);
    }

    return false;
  }

  function apdevHasSelectedFilter(form) {
    const formData = new FormData(form);

    for (const [key, value] of formData.entries()) {
      const normalizedValue = String(value).trim();

      if (!key.startsWith("filter.") || normalizedValue === "") {
        continue;
      }

      const input = form.querySelector(`[name="${CSS.escape(key)}"]`);

      if (apdevIsDefaultPriceInput(input)) {
        continue;
      }

      return true;
    }

    return false;
  }

  function apdevInitForm(form) {
    if (!form) {
      return;
    }

    apdevToggleButton(form);
  }

  function apdevToggleButton(form) {
    const button = form && form.querySelector(apdevSelectors.button);

    if (!button) {
      return;
    }

    button.hidden = !apdevHasSelectedFilter(form);
  }

  function apdevAppendFormData(url, form) {
    const formData = new FormData(form);

    formData.forEach((value, key) => {
      const normalizedValue = String(value).trim();

      if (normalizedValue === "") {
        return;
      }

      url.searchParams.append(key, normalizedValue);
    });
  }

  function apdevRemoveDefaultPriceBounds(url, form) {
    const minInput = form.querySelector(apdevSelectors.priceFrom);
    const maxInput = form.querySelector(apdevSelectors.priceTo);

    if (minInput && Number(minInput.value) === Number(minInput.min)) {
      url.searchParams.delete(minInput.name);
    }

    if (maxInput && Number(maxInput.value) === Number(maxInput.max)) {
      url.searchParams.delete(maxInput.name);
    }
  }

  function apdevPreserveCurrentParams(url) {
    const currentUrl = new URL(window.location.href);

    apdevPreservedParams.forEach((key) => {
      const value = currentUrl.searchParams.get(key);

      if (value) {
        url.searchParams.set(key, value);
      }
    });
  }

  function apdevAddExternalSort(url, form) {
    if (form.querySelector("[name='sort_by']")) {
      return;
    }

    const externalSort = document.querySelector(apdevSelectors.externalSort);

    if (externalSort && externalSort.name && externalSort.value) {
      url.searchParams.set(externalSort.name, externalSort.value);
    }
  }

  function apdevBuildUrl(form) {
    const url = new URL(window.location.pathname, window.location.origin);

    apdevAppendFormData(url, form);
    apdevRemoveDefaultPriceBounds(url, form);
    apdevPreserveCurrentParams(url);
    apdevAddExternalSort(url, form);

    return url;
  }

  function apdevChangeHandler(event) {
    const form = apdevGetForm(event);

    if (!form) {
      return;
    }

    event.stopPropagation();
    apdevToggleButton(form);
  }

  function apdevInputHandler(event) {
    const form = apdevGetForm(event);

    if (form) {
      apdevToggleButton(form);
    }
  }

  function apdevSubmitHandler(event) {
    const form = apdevGetForm(event);

    if (!form) {
      return;
    }

    event.preventDefault();
    window.location.href = apdevBuildUrl(form).toString();
  }

  function apdevInit() {
    document.querySelectorAll(apdevSelectors.form).forEach(apdevInitForm);
    document.addEventListener("change", apdevChangeHandler, true);
    document.addEventListener("input", apdevInputHandler, true);
    document.addEventListener("submit", apdevSubmitHandler, true);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", apdevInit, { once: true });
  } else {
    apdevInit();
  }
})();
